/**
 * AFO addition — analytics events bridge (2026-09-16).
 * Tema tarafındaki dönüşüm etkileşimlerini Shopify'ın müşteri-olayı kanalına yayınlar
 * (Shopify.analytics.publish). Admin'deki "AFO GA4 events" custom pixel'i bu olaylara
 * abone olup GA4'e gönderir (~/Downloads/AFO-GA4-Custom-Pixel.js). Burada GA/gtag YOK.
 *
 * Olaylar (customData ile):
 *  afo_consultation_click  — cal.com linkleri (Interior Design "Book a Free 30-Min Consultation")
 *  afo_inquire_click       — PDP "Contact Us to Order" (teklif) butonu; product
 *  afo_commission_click    — satılmış eser "Commission a similar piece"; product
 *  afo_form_submit         — /contact formları gönderilirken (form_kind: contact | trade | newsletter)
 */
(() => {
  const publish = (name, data) => {
    try {
      const a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(name, { ...data, page_path: location.pathname });
    } catch (e) { /* analytics asla sayfayı kırmasın */ }
  };

  const productTitle = () => (document.querySelector('.afo-pp-title, h1')?.textContent || '').trim().slice(0, 120);

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a, button');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (href.includes('cal.com')) return publish('afo_consultation_click', { link_url: href, link_text: (a.textContent || '').trim().slice(0, 80) });
    if (a.classList.contains('afo-quote-cta__button')) return publish('afo_inquire_click', { product: productTitle(), link_url: href });
    if (a.classList.contains('afo-sold-cta__button')) return publish('afo_commission_click', { product: productTitle(), link_url: href });
  }, { capture: true, passive: true });

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.startsWith('/contact')) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
    const type = (form.querySelector('input[name="form_type"]')?.value || '').toLowerCase();
    const kind = form.dataset.afoForm || (type === 'customer' ? 'newsletter' : (/trade/.test(location.pathname) || /trade/i.test(form.id || '') ? 'trade' : 'contact'));
    publish('afo_form_submit', { form_kind: kind, form_id: form.id || '' });
  }, { capture: true, passive: true });
})();
